// @ts-nocheck
import React, { useContext, useEffect, useState, useCallback } from 'react';
import Context from '../../context/Context';
import { fetchForm, editForm, fetchFormElements, editFormElement } from '../../context/forms/FormsAction';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { URL } from '../../service/Service';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PaymentsIcon from '@mui/icons-material/Payments';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import TuneIcon from '@mui/icons-material/Tune';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SyncIcon from '@mui/icons-material/Sync';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import PaletteOutlinedIcon from '@mui/icons-material/PaletteOutlined';
import PaymentMethodIcon from '../../components/PaymentMethodIcon';
import { FORM_THEMES, contrastRatio, getAccessibleTextColor, getThemeStyle, isValidHexColor } from '../../config/formThemes';
import { API_KEY_HTML_PATTERN, requiresApiKey, validatePaymentConfiguration } from '../../utils/paymentConfiguration';
import TranslateIcon from '@mui/icons-material/Translate';
import { useI18n } from '../../i18n/I18nContext';

const getLocalTodayIsoDate = () => {
    const today = new Date();
    const localToday = new Date(today.getTime() - (today.getTimezoneOffset() * 60_000));
    return localToday.toISOString().slice(0, 10);
};

const getUserRole = () => {
    try {
        const token = sessionStorage.getItem('jwt');
        if (!token) return 'USER';
        return jwtDecode(token)?.authorities?.[0]?.authority ?? 'USER';
    } catch (_error) {
        return 'USER';
    }
};

const PAYMENT_METHODS = [
    {
        label: 'Numerário',
        description: 'Registo manual do pagamento.',
    },
    {
        label: 'Multibanco',
        description: 'Referência Multibanco com prazo opcional.',
    },
    {
        label: 'MB WAY',
        description: 'Pagamento rápido por telemóvel.',
    },
    {
        label: 'Cartão de Crédito',
        description: 'Pagamento por cartão.',
    },
    {
        label: 'Google Pay',
        description: 'Pagamento rápido com a carteira Google.',
    },
    {
        label: 'Apple Pay',
        description: 'Pagamento rápido com a carteira Apple.',
    },
];

const StepHeader = ({ onBack, submitDisabled, submitDisabledReason }) => {
    const steps = [
        { label: 'Editor', description: 'Campos do formulário' },
        { label: 'Definições', description: 'Pagamentos e regras' },
        { label: 'Upload Imagem', description: 'Marca e publicação' },
    ];

    return (
        <div className="sticky top-0 z-30 -mx-4 -mt-4 border-b border-slate-200 bg-slate-50/95 px-4 py-4 backdrop-blur sm:-mx-6 sm:-mt-5 sm:px-6 lg:-mx-8 lg:px-8">
            <div className="mx-auto w-full max-w-[1600px]">
                <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
                    <div>
                        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-emerald-700">Definições</p>
                        <h1 className="mt-1 text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">Pagamentos, stock e regras</h1>
                        <p className="mt-1 text-sm text-slate-500">Organizado por secções para não obrigares o utilizador a procurar opções num formulário gigante.</p>
                    </div>

                    <div className="flex shrink-0 flex-col items-end gap-2">
                        <div className="flex items-center gap-2">
                            <button
                                className="rounded-xl border border-slate-300 bg-white px-4 py-2 text-sm font-semibold text-slate-700 shadow-sm transition hover:bg-slate-100"
                                onClick={onBack}
                                type="button"
                            >
                                Anterior
                            </button>
                            <button
                                className={`rounded-xl px-5 py-2 text-sm font-semibold text-white shadow-sm transition ${submitDisabled ? 'cursor-not-allowed bg-slate-400' : 'bg-green-cl hover:bg-opacity-90'}`}
                                type="submit"
                                disabled={submitDisabled}
                                title={submitDisabledReason || undefined}
                            >
                                Seguinte
                            </button>
                        </div>
                        {submitDisabled && submitDisabledReason && (
                            <p className="max-w-sm text-right text-xs font-semibold text-red-600">
                                {submitDisabledReason}
                            </p>
                        )}
                    </div>
                </div>

                <div className="mt-5 grid gap-3 md:grid-cols-3">
                    {steps.map((step, index) => {
                        const current = index === 1;
                        const done = index < 1;

                        return (
                            <div
                                key={step.label}
                                className={`rounded-2xl border p-4 transition ${current ? 'border-emerald-700 bg-white shadow-sm' : done ? 'border-emerald-100 bg-emerald-50' : 'border-slate-200 bg-white'}`}
                            >
                                <div className="flex items-center gap-3">
                                    <div className={`flex h-9 w-9 items-center justify-center rounded-full text-sm font-bold ${current ? 'bg-green-cl text-white' : done ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-100 text-slate-500'}`}>
                                        {index + 1}
                                    </div>
                                    <div>
                                        <p className="text-sm font-bold text-slate-900">{step.label}</p>
                                        <p className="text-xs text-slate-500">{step.description}</p>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

const SectionCard = ({ icon, title, description, children }) => (
    <section className="min-w-0 overflow-hidden rounded-3xl border border-slate-200 bg-white p-5 shadow-sm sm:p-6">
        <div className="mb-6 flex min-w-0 items-start gap-3">
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-emerald-50 text-emerald-700">
                {icon}
            </div>
            <div className="min-w-0">
                <h2 className="text-lg font-bold text-slate-900">{title}</h2>
                {description && <p className="mt-1 text-sm text-slate-500">{description}</p>}
            </div>
        </div>
        {children}
    </section>
);

const Field = ({ label, hint, children }) => (
    <div className="min-w-0">
        <label className="mb-1.5 block text-sm font-bold text-slate-800">{label}</label>
        {children}
        {hint && <p className="mt-1.5 text-xs leading-5 text-slate-500">{hint}</p>}
    </div>
);

const ThemePreview = ({ theme, customThemeColor, customThemeBase, formName }) => {
    const selectedTheme = FORM_THEMES.find((option) => option.id === theme) ?? FORM_THEMES[0];
    const previewStyle = getThemeStyle(theme, customThemeColor, customThemeBase);

    return (
        <aside className="min-w-0 xl:sticky xl:top-40 xl:self-start">
            <div className="overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-[0_22px_60px_rgba(15,23,42,0.12)]">
                <div className="flex items-center justify-between border-b border-slate-200 bg-slate-50 px-4 py-3">
                    <div className="flex items-center gap-1.5" aria-hidden="true">
                        <span className="h-2.5 w-2.5 rounded-full bg-rose-300" />
                        <span className="h-2.5 w-2.5 rounded-full bg-amber-300" />
                        <span className="h-2.5 w-2.5 rounded-full bg-emerald-300" />
                    </div>
                    <span className="rounded-full bg-white px-3 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-slate-500 shadow-sm">
                        Pré-visualização
                    </span>
                </div>

                <div
                    className="min-h-[430px] p-5 transition-colors duration-300"
                    style={{ ...previewStyle, background: 'var(--form-page-background)', color: 'var(--form-text)' }}
                >
                    <div className="mb-4 flex items-center justify-between gap-3">
                        <div>
                            <p className="text-[10px] font-extrabold uppercase tracking-[0.2em]" style={{ color: 'var(--form-accent)' }}>Formulário</p>
                            <p className="mt-1 text-xs font-semibold" style={{ color: 'var(--form-muted)' }}>{selectedTheme.name}</p>
                        </div>
                        <span className="h-9 w-9 rounded-xl" style={{ background: 'var(--form-soft)', border: '1px solid var(--form-border)' }} />
                    </div>

                    <div
                        className="p-5 shadow-lg transition-colors duration-300"
                        style={{ background: 'var(--form-surface)', border: '1px solid var(--form-border)', borderRadius: 'var(--form-radius)' }}
                    >
                        <h3 className="truncate text-lg font-extrabold" style={{ color: 'var(--form-text)' }}>
                            {formName?.trim() || 'Nome do formulário'}
                        </h3>
                        <p className="mt-1 text-xs leading-5" style={{ color: 'var(--form-muted)' }}>
                            Preencha os seus dados e confirme o pedido.
                        </p>

                        <div className="mt-5">
                            <p className="mb-1.5 text-[11px] font-bold" style={{ color: 'var(--form-text)' }}>Nome completo</p>
                            <div className="h-10 rounded-xl" style={{ background: 'var(--form-surface)', border: '1px solid var(--form-border)' }} />
                        </div>

                        <div className="mt-4 rounded-2xl p-3" style={{ background: 'var(--form-soft)', border: '1px solid var(--form-border)' }}>
                            <div className="flex items-center justify-between gap-3">
                                <div>
                                    <p className="text-xs font-bold" style={{ color: 'var(--form-text)' }}>Inscrição</p>
                                    <p className="mt-0.5 text-[10px]" style={{ color: 'var(--form-muted)' }}>1 artigo</p>
                                </div>
                                <strong className="text-sm" style={{ color: 'var(--form-text)' }}>25,00 €</strong>
                            </div>
                        </div>

                        <button
                            type="button"
                            tabIndex={-1}
                            className="mt-5 w-full rounded-xl px-4 py-3 text-xs font-extrabold shadow-md"
                            style={{ background: 'var(--form-accent)', color: 'var(--form-accent-text)' }}
                        >
                            Continuar
                        </button>
                    </div>
                </div>
            </div>
            <p className="mt-3 text-center text-xs leading-5 text-slate-500">
                A pré-visualização atualiza imediatamente. Guarda para aplicar o tema ao formulário público.
            </p>
        </aside>
    );
};

const inputClass = 'min-w-0 w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-900 shadow-sm outline-none transition focus:border-emerald-500 focus:ring-4 focus:ring-emerald-100';
const selectClass = inputClass;

const Toast = ({ type = 'success', title, message, onClose }) => {
    if (!message) return null;

    const styles = type === 'error'
        ? 'border-red-200 bg-red-50 text-red-700'
        : type === 'warning'
            ? 'border-amber-200 bg-amber-50 text-amber-700'
            : 'border-emerald-200 bg-emerald-50 text-emerald-700';

    return (
        <div className="fixed bottom-5 right-5 z-50 w-[min(440px,calc(100vw-2rem))]">
            <div className={`rounded-2xl border px-5 py-4 shadow-xl ${styles}`}>
                <div className="flex items-start justify-between gap-4">
                    <div>
                        <p className="text-sm font-bold">{title}</p>
                        <p className="mt-1 text-sm">{message}</p>
                    </div>
                    <button className="text-lg leading-none opacity-70 hover:opacity-100" type="button" onClick={onClose}>×</button>
                </div>
            </div>
        </div>
    );
};

const PaymentMethodCard = ({ method, checked, onChange }) => (
    <label className={`group flex cursor-pointer gap-4 rounded-3xl border p-4 shadow-sm transition hover:-translate-y-0.5 hover:shadow-md ${checked ? 'border-emerald-500 bg-emerald-50' : 'border-slate-200 bg-white'}`}>
        <input
            type="checkbox"
            className="mt-1 h-4 w-4 rounded border-slate-300 text-emerald-700 focus:ring-emerald-500"
            checked={checked}
            onChange={onChange}
        />
        <div className="flex flex-1 gap-3">
            <span className={`flex h-11 w-14 shrink-0 items-center justify-center rounded-2xl p-1.5 ${checked ? 'bg-white text-emerald-700' : 'bg-slate-100 text-slate-600'}`}>
                <PaymentMethodIcon method={method.label} className="h-8 w-11" />
            </span>
            <span>
                <span className="block text-sm font-bold text-slate-900">{method.label}</span>
                <span className="mt-1 block text-xs leading-5 text-slate-500">{method.description}</span>
            </span>
        </div>
    </label>
);

const FormWizard2 = () => {
    const { language: uiLanguage } = useI18n();
    const uiLocale = uiLanguage === 'PT' ? 'pt-PT' : uiLanguage === 'ES' ? 'es-ES' : 'en-GB';
    const { state, dispatch } = useContext(Context);
    const { form } = state;
    const { data } = state.formelements;
    const formData = form?.data ?? {};
    const { idform } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const userRole = getUserRole();
    const token = sessionStorage.getItem('jwt');
    const isAdmin = userRole === 'ADMIN';
    const baseFormPath = isAdmin ? `/admin/forms/${idform}` : `/forms/${idform}`;

    const [name, setName] = useState(formData.name ?? '');
    const [info, setInfo] = useState(formData.info ?? '');
    const [latitude, setLatitude] = useState(formData.latitude ?? 0);
    const [longitude, setLongitude] = useState(formData.longitude ?? 0);
    const [locationUrl, setLocationUrl] = useState(formData.locationUrl ?? '');
    const [apiKey, setApiKey] = useState(formData.apiKey ?? '');
    const [showError, setShowError] = useState(false);
    const [errorMessages, setErrorMessages] = useState([]);
    const [warningMessage, setWarningMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [paymentOptions, setPaymentOptions] = useState(formData.paymentOptions ?? []);
    const [isFormValid, setIsFormValid] = useState(false);
    const [stock, setStock] = useState(formData.stock ?? 0);
    const [stockOption, setStockOption] = useState(formData.stockOption ?? 'UNLIMITED');
    const [saveReplyIp, setSaveReplyIp] = useState(formData.saveReplyIp ?? false);
    const [ipMessage, setIpMessage] = useState(formData.ipMessage ?? '');
    const [maxQuantityPerElement, setMaxQuantityPerElement] = useState(formData.maxQuantityPerElement ?? 0);
    const [maxQuantityOption, setMaxQuantityOption] = useState(formData.maxQuantityOption ?? 'UNLIMITED');
    const [stockDecrementOption, setStockDecrementOption] = useState(formData.stockDecrementOption ?? 'PENDING');
    const [formElements, setFormElements] = useState([]);
    const [quantities, setQuantities] = useState({});
    const [maxQuantities, setMaxQuantities] = useState({});
    const [callbackSuccess, setCallbackSuccess] = useState('');
    const [callbackError, setCallbackError] = useState('');
    const [webhookAction, setWebhookAction] = useState('');
    const [webhookConfiguration, setWebhookConfiguration] = useState(null);
    const [showWebhookTechnicalDetails, setShowWebhookTechnicalDetails] = useState(false);
    const [showCoordinates, setShowCoordinates] = useState((formData.latitude ?? 0) !== 0 && (formData.longitude ?? 0) !== 0);
    const [mbStartDate, setMbStartDate] = useState(formData.mbStartDate ?? '');
    const [mbEndDate, setMbEndDate] = useState(formData.mbEndDate ?? '');
    const [mbLimitDays, setMbLimitDays] = useState(formData.mbLimitDays ?? '');
    const [sendEmailOnPaidWebhook, setSendEmailOnPaidWebhook] = useState(formData.sendEmailOnPaidWebhook ?? false);
    const [expirationDate, setExpirationDate] = useState(formData.expirationDate ?? '');
    const [formLanguage, setFormLanguage] = useState(formData.language ?? 'AUTO');
    const [useDefaultMbDates, setUseDefaultMbDates] = useState(true);
    const [theme, setTheme] = useState(formData.theme ?? 'EUPAGO');
    const [customThemeColor, setCustomThemeColor] = useState(formData.customThemeColor ?? '#2563EB');
    const [customThemeBase, setCustomThemeBase] = useState(formData.customThemeBase ?? 'LIGHT');
    const apiKeyRequired = requiresApiKey(paymentOptions);
    const paymentConfigurationError = validatePaymentConfiguration(paymentOptions, apiKey);
    const expirationDateError = expirationDate && expirationDate < getLocalTodayIsoDate()
        ? 'A data de expiração não pode ser anterior à data atual.'
        : '';
    const submitDisabledReason = !name?.trim()
        ? 'Preenche o nome do formulário para continuar.'
        : paymentConfigurationError || expirationDateError
            || (theme === 'CUSTOM' && !isValidHexColor(customThemeColor) ? 'Indica uma cor personalizada válida.' : '');

    useEffect(() => {
        const isAdminPath = location.pathname.startsWith('/admin/forms/');
        const isFormWizard2Path = location.pathname.endsWith('/formwizard/2');

        if (isAdminPath && isFormWizard2Path && userRole !== 'ADMIN') {
            navigate('/login');
        }
    }, [location.pathname, navigate, userRole]);

    useEffect(() => {
        const url = `${URL}/api/forms/${idform}/formelements`;
        const urlForm = `${URL}/api/forms/${idform}`;

        async function fetchData() {
            await fetchFormElements(url, {}, dispatch);
            await fetchForm(urlForm, {}, dispatch);
        }

        fetchData();
    }, [dispatch, idform]);

    useEffect(() => {
        setFormElements(Object.values(data ?? {}));
    }, [data]);

    useEffect(() => {
        const current = form?.data ?? {};

        setName(current.name ?? '');
        setInfo(current.info ?? '');
        setLatitude(current.latitude ?? 0);
        setLongitude(current.longitude ?? 0);
        setLocationUrl(current.locationUrl ?? '');
        setApiKey(current.apiKey ?? '');
        setPaymentOptions(current.paymentOptions ?? []);
        setStockOption(current.stockOption ?? 'UNLIMITED');
        setStock(current.stock ?? 0);
        setStockDecrementOption(current.stockDecrementOption ?? 'PENDING');
        setMaxQuantityOption(current.maxQuantityOption ?? 'UNLIMITED');
        setMaxQuantityPerElement(current.maxQuantityPerElement ?? 0);
        setSaveReplyIp(current.saveReplyIp ?? false);
        setIpMessage(current.ipMessage ?? '');
        setMbStartDate('');
        setMbEndDate('');
        setMbLimitDays(
            current.mbLimitDays
                ?? ((current.mbStartDate || current.mbEndDate) ? '1' : '')
        );
        setSendEmailOnPaidWebhook(current.sendEmailOnPaidWebhook ?? false);
        setExpirationDate(current.expirationDate ?? '');
        setFormLanguage(current.language ?? 'AUTO');
        setShowCoordinates((current.latitude ?? 0) !== 0 && (current.longitude ?? 0) !== 0);

        // The public configuration now exposes only "with deadline" (days)
        // and "without deadline". Legacy fixed dates are migrated to one day
        // the next time the form is saved.
        setUseDefaultMbDates(false);
        setTheme(current.theme ?? 'EUPAGO');
        setCustomThemeColor(current.customThemeColor ?? '#2563EB');
        setCustomThemeBase(current.customThemeBase ?? 'LIGHT');
    }, [form?.data?.id]);

    useEffect(() => {
        if (Array.isArray(formElements) && formElements.length > 0) {
            const initialQuantities = formElements
                .filter(element => element.element_type === 'price')
                .reduce((acc, element) => {
                    acc[element.id] = element.stock || 0;
                    return acc;
                }, {});

            const initialMaxQuantities = formElements
                .filter(element => element.element_type === 'price')
                .reduce((acc, element) => {
                    acc[element.id] = element.maxQuantityPerElement || 0;
                    return acc;
                }, {});

            setQuantities(initialQuantities);
            setMaxQuantities(initialMaxQuantities);
        }
    }, [formElements]);

    useEffect(() => {
        const paymentConfigurationValid = !validatePaymentConfiguration(paymentOptions, apiKey);
        const expirationDateValid = !expirationDate || expirationDate >= getLocalTodayIsoDate();
        setIsFormValid(Boolean(name?.trim()) && paymentConfigurationValid
            && expirationDateValid
            && (theme !== 'CUSTOM' || isValidHexColor(customThemeColor)));
    }, [name, apiKey, paymentOptions, expirationDate, theme, customThemeColor]);

    useEffect(() => {
        if (!idform || !token) return undefined;

        let active = true;
        const loadWebhookStatus = async () => {
            try {
                const response = await axios.get(`${URL}/callback/forms/${idform}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                if (active && response.status === 200) {
                    setWebhookConfiguration(response.data);
                }
            } catch {
                // There may be no local Webhooks 2.0 configuration yet.
            }
        };

        void loadWebhookStatus();
        window.addEventListener('focus', loadWebhookStatus);
        return () => {
            active = false;
            window.removeEventListener('focus', loadWebhookStatus);
        };
    }, [idform, token]);

    useEffect(() => {
        if (useDefaultMbDates && mbStartDate && mbEndDate && mbEndDate < mbStartDate) {
            setWarningMessage('A data de fim não pode ser anterior à data de início.');
        } else if (warningMessage === 'A data de fim não pode ser anterior à data de início.') {
            setWarningMessage('');
        }
    }, [useDefaultMbDates, mbStartDate, mbEndDate]);

    const updateHandler = useCallback(async () => {
        const url = `${URL}/api/forms/${idform}`;
        const request = {
            method: 'PATCH',
            headers: {
                'Content-type': 'application/json',
                Accept: 'application/json',
            },
            body: JSON.stringify({
                name,
                paymentOptions,
                apiKey: apiKey.trim(),
                info,
                latitude: showCoordinates ? latitude : 0,
                longitude: showCoordinates ? longitude : 0,
                locationUrl: locationUrl.trim(),
                stock,
                stockOption,
                stockDecrementOption,
                maxQuantityPerElement,
                maxQuantityOption,
                saveReplyIp,
                ipMessage: saveReplyIp ? ipMessage : '',
                mbStartDate: useDefaultMbDates ? mbStartDate : null,
                mbEndDate: useDefaultMbDates ? mbEndDate : null,
                mbLimitDays: (!mbStartDate && !mbEndDate && !useDefaultMbDates && mbLimitDays) ? mbLimitDays : null,
                sendEmailOnPaidWebhook,
                expirationDate: expirationDate || null,
                theme,
                customThemeColor: theme === 'CUSTOM' ? customThemeColor.toUpperCase() : null,
                customThemeBase,
                language: formLanguage,
            }),
        };

        await editForm(url, request, dispatch);
    }, [idform, name, paymentOptions, apiKey, info, latitude, longitude, locationUrl, showCoordinates, stock, stockOption, stockDecrementOption, maxQuantityPerElement, maxQuantityOption, saveReplyIp, ipMessage, useDefaultMbDates, mbStartDate, mbEndDate, mbLimitDays, sendEmailOnPaidWebhook, expirationDate, theme, customThemeColor, customThemeBase, formLanguage, dispatch]);

    const updateFormElement = async (formElementId, updateFields) => {
        const url = `${URL}/api/forms/${idform}/formelements/${formElementId}`;
        const request = {
            method: 'PATCH',
            headers: {
                'Content-type': 'application/json',
                Accept: 'application/json',
            },
            body: JSON.stringify({
                ...updateFields,
                maxQuantityOption,
                stockOption,
            }),
        };

        await editFormElement(url, request, dispatch);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!isFormValid) {
            const messages = [];
            if (!name?.trim()) {
                messages.push('Preenche o nome do formulário.');
            }
            const paymentConfigurationError = validatePaymentConfiguration(paymentOptions, apiKey);
            if (paymentConfigurationError) {
                messages.push(paymentConfigurationError);
            }
            if (theme === 'CUSTOM' && !isValidHexColor(customThemeColor)) {
                messages.push('Indica uma cor personalizada válida.');
            }
            if (expirationDate && expirationDate < getLocalTodayIsoDate()) {
                messages.push('A data de expiração não pode ser anterior à data atual.');
            }
            setErrorMessages(messages.length > 0 ? messages : ['Revê os dados do formulário.']);
            setShowError(true);
            return;
        }

        if (useDefaultMbDates && mbStartDate && mbEndDate && mbEndDate < mbStartDate) {
            setWarningMessage('A data de fim não pode ser anterior à data de início.');
            return;
        }

        setErrorMessages([]);
        setShowError(false);

        try {
            await updateHandler();

            const elementUpdatePromises = [];

            if (stockOption === 'TYPE_LIMITED') {
                formElements
                    .filter(element => element.element_type === 'price')
                    .forEach(element => {
                        elementUpdatePromises.push(updateFormElement(element.id, { stock: quantities[element.id] }));
                    });
            }

            if (maxQuantityOption === 'TYPE_LIMITED') {
                formElements
                    .filter(element => element.element_type === 'price')
                    .forEach(element => {
                        elementUpdatePromises.push(updateFormElement(element.id, { maxQuantityPerElement: maxQuantities[element.id] }));
                    });
            }

            await Promise.all(elementUpdatePromises);

            setSuccessMessage('O formulário foi guardado com sucesso. A avançar para o upload da imagem...');

            setTimeout(() => {
                navigate(`${baseFormPath}/formwizard/3`);
            }, 900);
        } catch (error) {
            console.error('Error during form update: ', error);
            setErrorMessages(['Ocorreu um erro ao atualizar o formulário. Por favor, tenta novamente.']);
            setShowError(true);
        }
    };

    const handleCheckboxChange = (event, option) => {
        if (event.target.checked) {
            setPaymentOptions(prevOptions => {
                const next = prevOptions.includes(option) ? prevOptions : [...prevOptions, option];
                if (option === 'Multibanco') {
                    setUseDefaultMbDates(false);
                }
                return next;
            });
        } else {
            setPaymentOptions(prevOptions => prevOptions.filter(paymentOption => paymentOption !== option));
        }
    };

    const handleMaxQuantityPerElementChange = (event) => {
        let value = parseInt(event.target.value, 10);
        if (isNaN(value)) value = 0;
        if (value > 9999) {
            value = 9999;
            setWarningMessage('O valor máximo permitido é 9999.');
        }
        setMaxQuantityPerElement(value);
    };

    const handleQuantityChange = (id, event) => {
        setQuantities(prev => ({
            ...prev,
            [id]: event.target.value,
        }));
    };

    const handleMaxQuantityChange = (id, event) => {
        let value = parseInt(event.target.value, 10);
        if (isNaN(value)) value = 0;
        if (value > 9999) {
            value = 9999;
            setWarningMessage('O valor máximo permitido é 9999.');
        }
        setMaxQuantities(prev => ({
            ...prev,
            [id]: value,
        }));
    };

    const handleWebhookSync = async () => {
        setWebhookAction('repair');
        setCallbackError('');
        setCallbackSuccess('');

        try {
            const response = await axios.post(`${URL}/callback/forms/${idform}/repair`, null, {
                headers: { Authorization: `Bearer ${token}` },
            });

            setWebhookConfiguration(response.data);
            setCallbackSuccess(
                response.data?.repaired
                    ? 'O Webhook 2.0 estava desatualizado e foi reparado com sucesso.'
                    : 'Webhook 2.0 verificado: a configuração está operacional.'
            );
        } catch (error) {
            setCallbackError(
                typeof error?.response?.data === 'string'
                    ? error.response.data
                    : 'Não foi possível verificar ou reparar o Webhook 2.0.'
            );
            console.error('Error:', error);
        } finally {
            setWebhookAction('');
        }
    };

    const priceElements = Array.isArray(formElements)
        ? formElements.filter(element => element.element_type === 'price')
        : [];

    return (
        <div className="min-h-screen overflow-x-hidden bg-slate-50 px-4 py-4 text-slate-900 sm:px-6 sm:py-5 lg:px-8">
            <form onSubmit={handleSubmit}>
                <StepHeader
                    onBack={() => navigate(`${baseFormPath}/formwizard/1`)}
                    submitDisabled={!isFormValid}
                    submitDisabledReason={submitDisabledReason}
                />

                <div className="mx-auto mt-6 grid w-full max-w-[1600px] min-w-0 grid-cols-1 gap-5 2xl:grid-cols-[minmax(0,1fr)_360px]">
                    <div className="min-w-0 space-y-5">
                        <SectionCard
                            icon={<TuneIcon />}
                            title="Dados principais"
                            description="Informação que identifica o formulário e aparece para o utilizador."
                        >
                            <div className="grid min-w-0 gap-5 lg:grid-cols-2">
                                <Field label="Nome do formulário" hint="Exemplo: Inscrição Workshop Local">
                                    <input
                                        className={inputClass}
                                        type="text"
                                        value={name}
                                        onChange={(event) => setName(event.target.value)}
                                        required
                                    />
                                </Field>

                                <Field
                                    label={`Chave API${apiKeyRequired ? ' *' : ' (opcional)'}`}
                                    hint={apiKeyRequired
                                        ? 'Obrigatória porque selecionaste um método de pagamento online.'
                                        : 'Necessária para Multibanco, MB WAY, Cartão de Crédito, Google Pay ou Apple Pay.'}
                                >
                                    <input
                                        className={inputClass}
                                        type="text"
                                        value={apiKey}
                                        onChange={(event) => setApiKey(event.target.value)}
                                        required={apiKeyRequired}
                                        pattern={API_KEY_HTML_PATTERN}
                                        maxLength={24}
                                        spellCheck={false}
                                        title="Formato esperado: 322c-1e1b-e392-d02e-bec6 ou demo-xxxx-xxxx-xxxx-xxx"
                                        placeholder={apiKeyRequired ? 'Chave API Eupago obrigatória' : 'Opcional para formulários com Numerário'}
                                    />
                                    {paymentConfigurationError && (
                                        <p className="mt-2 text-xs font-semibold text-red-600" role="alert">
                                            {paymentConfigurationError}
                                        </p>
                                    )}
                                </Field>
                            </div>

                            <div className="mt-5 grid min-w-0 gap-5 lg:grid-cols-[minmax(0,2fr)_minmax(280px,1fr)]">
                                <Field label="Informação do formulário">
                                    <textarea
                                        className={`${inputClass} min-h-[150px] resize-y leading-6`}
                                        value={info ?? ''}
                                        onChange={(event) => setInfo(event.target.value)}
                                    />
                                </Field>
                                <Field label="Data de expiração" hint="Opcional. No dia seguinte, o formulário deixa de aceitar acessos e respostas.">
                                    <input
                                        className={inputClass}
                                        type="date"
                                        min={getLocalTodayIsoDate()}
                                        value={expirationDate}
                                        onChange={(event) => setExpirationDate(event.target.value)}
                                    />
                                    {expirationDate && (
                                        <button
                                            type="button"
                                            onClick={() => setExpirationDate('')}
                                            className="mt-2 text-xs font-semibold text-slate-500 hover:text-slate-800"
                                        >
                                            Remover data
                                        </button>
                                    )}
                                </Field>
                            </div>
                        </SectionCard>

                        <SectionCard
                            icon={<PaletteOutlinedIcon />}
                            title="Aparência do formulário"
                            description="Escolhe um tema pronto a usar ou aplica a cor da tua marca."
                        >
                            <div className="grid min-w-0 gap-6 xl:grid-cols-[minmax(0,1.7fr)_minmax(320px,0.8fr)]">
                                <div className="min-w-0">
                                    <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
                                        {FORM_THEMES.map((option) => {
                                            const selected = theme === option.id;
                                            return (
                                                <button
                                                    key={option.id}
                                                    type="button"
                                                    role="radio"
                                                    aria-checked={selected}
                                                    onClick={() => setTheme(option.id)}
                                                    className={`group min-w-0 rounded-2xl border p-3.5 text-left transition hover:-translate-y-0.5 hover:shadow-md ${selected ? 'border-emerald-500 bg-emerald-50 ring-2 ring-emerald-100' : 'border-slate-200 bg-white'}`}
                                                >
                                                    <span className="flex h-full min-h-[92px] flex-col justify-between gap-3">
                                                        <span className="min-w-0">
                                                            <span className="block text-sm font-extrabold text-slate-900">{option.name}</span>
                                                            <span className="mt-1 block text-xs leading-5 text-slate-500">
                                                                {option.description}
                                                            </span>
                                                        </span>
                                                        <span className="flex -space-x-1 self-end" aria-label={`Paleta ${option.name}`}>
                                                            {option.preview.map((color) => (
                                                                <span key={color} className="h-6 w-6 rounded-full border-2 border-white shadow-sm ring-1 ring-slate-200/70" style={{ backgroundColor: color }} />
                                                            ))}
                                                        </span>
                                                    </span>
                                                </button>
                                            );
                                        })}
                                    </div>

                                    {theme === 'CUSTOM' && (
                                        <div className="mt-5 grid gap-4 rounded-3xl border border-slate-200 bg-slate-50 p-5 md:grid-cols-2">
                                            <Field label="Cor da marca (HEX)" hint="Usada apenas em botões, seleções e destaques.">
                                                <div className="flex gap-2">
                                                    <input
                                                        type="color"
                                                        value={isValidHexColor(customThemeColor) ? customThemeColor : '#2563EB'}
                                                        onChange={(event) => setCustomThemeColor(event.target.value.toUpperCase())}
                                                        className="h-12 w-14 shrink-0 cursor-pointer rounded-xl border border-slate-200 bg-white p-1"
                                                        aria-label="Escolher cor da marca"
                                                    />
                                                    <input
                                                        className={inputClass}
                                                        value={customThemeColor}
                                                        maxLength={7}
                                                        placeholder="#2563EB"
                                                        onChange={(event) => setCustomThemeColor(event.target.value)}
                                                    />
                                                </div>
                                                {!isValidHexColor(customThemeColor) && (
                                                    <p className="mt-2 text-xs font-semibold text-red-600">Usa o formato #RRGGBB, por exemplo #2563EB.</p>
                                                )}
                                            </Field>
                                            <Field label="Base do formulário" hint="Mantém a leitura confortável em fundo claro ou escuro.">
                                                <select className={selectClass} value={customThemeBase} onChange={(event) => setCustomThemeBase(event.target.value)}>
                                                    <option value="LIGHT">Clara</option>
                                                    <option value="DARK">Escura</option>
                                                </select>
                                            </Field>
                                            {isValidHexColor(customThemeColor) && (
                                                <div className="md:col-span-2 flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-slate-200 bg-white p-4">
                                                    <div>
                                                        <p className="text-sm font-bold text-slate-900">Contraste automático aprovado</p>
                                                        <p className="mt-1 text-xs text-slate-500">
                                                            O texto do botão será {getAccessibleTextColor(customThemeColor) === '#ffffff' ? 'branco' : 'escuro'} · contraste {contrastRatio(customThemeColor, getAccessibleTextColor(customThemeColor)).toFixed(1)}:1.
                                                        </p>
                                                    </div>
                                                    <span
                                                        className="rounded-xl px-5 py-2.5 text-sm font-bold shadow-sm"
                                                        style={{ backgroundColor: customThemeColor, color: getAccessibleTextColor(customThemeColor) }}
                                                    >
                                                        Pré-visualizar botão
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>

                                <ThemePreview
                                    theme={theme}
                                    customThemeColor={customThemeColor}
                                    customThemeBase={customThemeBase}
                                    formName={name}
                                />
                            </div>
                        </SectionCard>

                        <SectionCard
                            icon={<TranslateIcon />}
                            title="Idioma do formulário"
                            description="Define o idioma da experiência pública sem alterar o idioma do backoffice."
                        >
                            <Field
                                label="Idioma do formulário"
                                hint="AUTO tenta primeiro o idioma do browser e, se não for PT, ES ou EN, usa o país inferido pelo IP do visitante."
                            >
                                <select
                                    value={formLanguage}
                                    onChange={(event) => setFormLanguage(event.target.value)}
                                    className={selectClass}
                                >
                                    <option value="AUTO">AUTO — browser e depois IP</option>
                                    <option value="PT">PT — Português</option>
                                    <option value="ES">ES — Espanhol</option>
                                    <option value="EN">EN — Inglês</option>
                                </select>
                            </Field>
                        </SectionCard>

                        <SectionCard
                            icon={<SyncIcon />}
                            title="Webhooks 2.0"
                            description="Recebe automaticamente as notificações de pagamento e permite verificar manualmente a configuração do canal."
                        >
                            {webhookConfiguration?.syncStatus === 'SYNC_REQUIRED' && (
                                <div className="mb-4 rounded-2xl border border-amber-200 bg-amber-50 p-4">
                                    <div className="flex items-start gap-3">
                                        <span className="mt-0.5 flex h-8 w-8 flex-none items-center justify-center rounded-full bg-amber-100 text-lg font-bold text-amber-700">!</span>
                                        <div>
                                            <p className="font-bold text-amber-900">Verificação necessária</p>
                                            <p className="mt-1 text-sm leading-6 text-amber-800">
                                                A configuração local não coincide com o endpoint esperado, ou uma notificação não pôde ser validada. Usa a verificação abaixo para confirmar e reparar o canal.
                                            </p>
                                            {webhookConfiguration.lastFailureAt && (
                                                <p className="mt-2 text-xs font-semibold text-amber-700">
                                                    Falha detetada em {new Date(webhookConfiguration.lastFailureAt).toLocaleString(uiLocale)}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="grid min-w-0 gap-4 lg:grid-cols-[220px_minmax(0,1fr)]">
                                <div className="flex flex-col justify-center rounded-2xl border border-slate-200 bg-slate-50 p-4">
                                    <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">Estado</p>
                                    <div className="mt-2 flex items-center gap-2">
                                        <span className={`h-2.5 w-2.5 rounded-full ${
                                            webhookConfiguration?.endpointMatches && webhookConfiguration?.syncStatus !== 'SYNC_REQUIRED'
                                                ? 'bg-emerald-500'
                                                : webhookConfiguration?.webhookVersion ? 'bg-amber-500' : 'bg-slate-300'
                                        }`} />
                                        <p className="font-bold text-slate-900">
                                            {webhookConfiguration?.endpointMatches && webhookConfiguration?.syncStatus !== 'SYNC_REQUIRED'
                                                ? 'Operacional'
                                                : webhookConfiguration?.webhookVersion ? 'Verificação necessária' : 'Ainda não verificado'}
                                        </p>
                                    </div>
                                    <p className="mt-2 text-xs text-slate-500">
                                        {webhookConfiguration?.webhookVersion
                                            ? `Versão ${webhookConfiguration.webhookVersion}`
                                            : 'A configuração ainda não foi obtida da Eupago.'}
                                    </p>
                                    {webhookConfiguration?.repaired && (
                                        <p className="mt-2 text-xs font-semibold text-emerald-700">Reparado nesta verificação.</p>
                                    )}
                                </div>

                                <div className="min-w-0 rounded-2xl border border-emerald-200 bg-emerald-50 p-4">
                                    <div className="flex h-full flex-col justify-center">
                                        <p className="text-sm font-bold text-emerald-900">Monitorização automática ativa</p>
                                        <p className="mt-1 text-xs leading-5 text-emerald-700">
                                            Os estados são atualizados quando a Eupago envia uma notificação para este webhook.
                                        </p>
                                        <p className="mt-2 text-xs font-semibold text-emerald-800">
                                            {webhookConfiguration?.lastWebhookAt
                                                ? `Última notificação: ${new Date(webhookConfiguration.lastWebhookAt).toLocaleString(uiLocale)}`
                                                : 'Ainda não foram recebidas notificações.'}
                                        </p>
                                        {webhookConfiguration?.synchronizedAt && (
                                            <p className="mt-1 text-xs font-semibold text-emerald-800">
                                                Última verificação: {new Date(webhookConfiguration.synchronizedAt).toLocaleString(uiLocale)}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="mt-4">
                                <div className="flex flex-wrap items-center justify-between gap-3">
                                    <button
                                        type="button"
                                        onClick={() => setShowWebhookTechnicalDetails((visible) => !visible)}
                                        className="text-xs font-semibold text-slate-600 underline decoration-slate-300 underline-offset-4 hover:text-slate-900"
                                    >
                                        {showWebhookTechnicalDetails ? 'Ocultar detalhes técnicos' : 'Mostrar detalhes técnicos'}
                                    </button>
                                    <button
                                        type="button"
                                        onClick={handleWebhookSync}
                                        disabled={Boolean(webhookAction) || !apiKey.trim() || apiKey.trim() !== String(form?.data?.apiKey || '').trim()}
                                        className={`inline-flex items-center justify-center gap-2 rounded-xl border px-4 py-2 text-xs font-bold shadow-sm transition disabled:cursor-not-allowed disabled:border-slate-200 disabled:bg-slate-100 disabled:text-slate-400 ${
                                            webhookConfiguration?.syncStatus === 'SYNC_REQUIRED'
                                                ? 'border-amber-600 bg-amber-600 text-white hover:bg-amber-700'
                                                : 'border-emerald-200 bg-white text-emerald-800 hover:border-emerald-400 hover:bg-emerald-50'
                                        }`}
                                    >
                                        <CloudUploadOutlinedIcon fontSize="small" />
                                        {webhookAction
                                            ? 'A verificar…'
                                            : webhookConfiguration?.syncStatus === 'SYNC_REQUIRED'
                                                ? 'Verificar e reparar'
                                                : 'Verificar configuração'}
                                    </button>
                                </div>
                                {showWebhookTechnicalDetails && (
                                    <div className="mt-3 space-y-3 rounded-2xl border border-slate-200 bg-slate-50 p-4">
                                        <div>
                                            <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">Endpoint esperado</p>
                                            <p className="mt-2 break-all rounded-xl border border-slate-200 bg-white px-3 py-2.5 font-mono text-xs leading-5 text-slate-700">
                                                {webhookConfiguration?.expectedWebhookUrl || 'Será calculado a partir do servidor atual durante a verificação.'}
                                            </p>
                                        </div>
                                        <div>
                                            <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">Endpoint registado na Eupago</p>
                                            <p className={`mt-2 break-all rounded-xl border bg-white px-3 py-2.5 font-mono text-xs leading-5 text-slate-700 ${
                                                webhookConfiguration?.endpointMatches === false ? 'border-amber-300' : 'border-slate-200'
                                            }`}>
                                                {webhookConfiguration?.webhookUrl || '—'}
                                            </p>
                                        </div>
                                        {webhookConfiguration?.synchronizedAt && (
                                            <p className="text-xs text-slate-500">
                                                Última verificação técnica: {new Date(webhookConfiguration.synchronizedAt).toLocaleString(uiLocale)}
                                            </p>
                                        )}
                                    </div>
                                )}
                            </div>

                            {apiKey.trim() && apiKey.trim() !== String(form?.data?.apiKey || '').trim() && (
                                <p className="mt-3 text-sm font-semibold text-amber-700">
                                    Guarda primeiro a nova Chave API antes de verificar o Webhook.
                                </p>
                            )}

                            {!apiKey.trim() && (
                                <p className="mt-3 rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-600">
                                    A verificação de Webhooks 2.0 fica indisponível sem Chave API. O formulário pode continuar a ser usado com Numerário.
                                </p>
                            )}

                        </SectionCard>

                        <SectionCard
                            icon={<PaymentsIcon />}
                            title="Métodos de pagamento"
                            description="Escolhe só os métodos necessários. A referência Multibanco pode ter ou não prazo."
                        >
                            <div className="grid gap-4 md:grid-cols-2">
                                {PAYMENT_METHODS.map(method => (
                                    <PaymentMethodCard
                                        key={method.label}
                                        method={method}
                                        checked={paymentOptions.includes(method.label)}
                                        onChange={(event) => handleCheckboxChange(event, method.label)}
                                    />
                                ))}
                            </div>

                            {paymentOptions.includes('Multibanco') && (
                                <div className="mt-5 rounded-3xl border border-slate-200 bg-slate-50 p-5">
                                    <div className="flex items-start gap-3">
                                        <AccountBalanceIcon className="text-emerald-700" />
                                        <div>
                                            <h3 className="font-bold text-slate-900">Prazo de pagamento Multibanco</h3>
                                            <p className="mt-1 text-sm text-slate-500">Define se a referência tem prazo ou fica disponível sem prazo.</p>
                                        </div>
                                    </div>

                                    <div className="mt-4 grid gap-3 md:grid-cols-2">
                                        <label className={`cursor-pointer rounded-2xl border p-4 ${!useDefaultMbDates && !mbLimitDays ? 'border-emerald-500 bg-white' : 'border-slate-200 bg-white'}`}>
                                            <input
                                                type="radio"
                                                name="mbDateOption"
                                                checked={!useDefaultMbDates && !mbLimitDays}
                                                onChange={() => {
                                                    setUseDefaultMbDates(false);
                                                    setMbStartDate('');
                                                    setMbEndDate('');
                                                    setMbLimitDays('');
                                                }}
                                            />
                                            <span className="ml-2 text-sm font-semibold">Sem prazo</span>
                                        </label>

                                        <label className={`cursor-pointer rounded-2xl border p-4 ${!!mbLimitDays ? 'border-emerald-500 bg-white' : 'border-slate-200 bg-white'}`}>
                                            <input
                                                type="radio"
                                                name="mbDateOption"
                                                checked={!!mbLimitDays}
                                                onChange={() => {
                                                    setUseDefaultMbDates(false);
                                                    setMbStartDate('');
                                                    setMbEndDate('');
                                                    setMbLimitDays('1');
                                                }}
                                            />
                                            <span className="ml-2 text-sm font-semibold">Com prazo</span>
                                        </label>
                                    </div>

                                    {!!mbLimitDays && (
                                        <div className="mt-4 max-w-xs">
                                            <Field label="N.º de dias para pagamento">
                                                <input
                                                    type="number"
                                                    min="1"
                                                    value={mbLimitDays}
                                                    onChange={(event) => {
                                                        const val = Math.max(1, parseInt(event.target.value) || 1);
                                                        setMbLimitDays(val.toString());
                                                    }}
                                                    className={inputClass}
                                                />
                                            </Field>
                                        </div>
                                    )}
                                </div>
                            )}
                        </SectionCard>

                        <SectionCard
                            icon={<Inventory2Icon />}
                            title="Stock e quantidades"
                            description="Controla disponibilidade total ou por produto/preço."
                        >
                            <div className="grid gap-5 lg:grid-cols-2">
                                <Field label="Limitação de stock">
                                    <select
                                        value={stockOption}
                                        onChange={(event) => setStockOption(event.target.value)}
                                        onWheel={() => document.activeElement.blur()}
                                        className={selectClass}
                                    >
                                        <option value="UNLIMITED">Ilimitado</option>
                                        <option value="LIMITED">Limitado</option>
                                        <option value="TYPE_LIMITED">Limitado por tipo</option>
                                    </select>
                                </Field>

                                {stockOption !== 'UNLIMITED' && (
                                    <Field label="Reduzir stock quando a compra estiver">
                                        <select
                                            value={stockDecrementOption}
                                            onChange={(event) => setStockDecrementOption(event.target.value)}
                                            className={selectClass}
                                        >
                                            <option value="PENDING">Pendente</option>
                                            <option value="PAID">Pago</option>
                                        </select>
                                    </Field>
                                )}
                            </div>

                            {stockOption === 'LIMITED' && (
                                <div className="mt-5 max-w-sm">
                                    <Field label="Stock disponível">
                                        <input
                                            type="number"
                                            value={stock}
                                            onChange={(event) => setStock(event.target.value)}
                                            onWheel={() => document.activeElement.blur()}
                                            className={inputClass}
                                            min="0"
                                        />
                                    </Field>
                                </div>
                            )}

                            {stockOption === 'TYPE_LIMITED' && (
                                <div className="mt-5 space-y-3 rounded-3xl border border-slate-200 bg-slate-50 p-4">
                                    {priceElements.length === 0 ? (
                                        <p className="text-sm text-amber-700">Ainda não tens campos de preço para aplicar stock por tipo.</p>
                                    ) : priceElements.map(element => (
                                        <div key={element.id} className="grid gap-3 md:grid-cols-[1fr_180px] md:items-center">
                                            <span className="text-sm font-semibold text-slate-700">{element.label || 'Campo de preço'}</span>
                                            <input
                                                type="number"
                                                value={quantities[element.id] ?? element.stock ?? 0}
                                                onChange={(event) => handleQuantityChange(element.id, event)}
                                                onWheel={() => document.activeElement.blur()}
                                                className={inputClass}
                                                min="0"
                                            />
                                        </div>
                                    ))}
                                </div>
                            )}

                            <div className="mt-6 grid gap-5 lg:grid-cols-2">
                                <Field
                                    label="Quantidade por resposta"
                                    hint="Limita o número máximo que uma pessoa pode escolher numa resposta."
                                >
                                    <select
                                        value={maxQuantityOption}
                                        onChange={(event) => setMaxQuantityOption(event.target.value)}
                                        className={selectClass}
                                    >
                                        <option value="UNLIMITED">Ilimitado</option>
                                        <option value="LIMITED">Limitado</option>
                                        <option value="TYPE_LIMITED">Limitado por tipo</option>
                                    </select>
                                </Field>

                                {maxQuantityOption === 'LIMITED' && (
                                    <Field label="Quantidade máxima">
                                        <input
                                            type="number"
                                            value={maxQuantityPerElement}
                                            onChange={handleMaxQuantityPerElementChange}
                                            onWheel={() => document.activeElement.blur()}
                                            className={inputClass}
                                            min="0"
                                        />
                                    </Field>
                                )}
                            </div>

                            {maxQuantityOption === 'TYPE_LIMITED' && (
                                <div className="mt-5 space-y-3 rounded-3xl border border-slate-200 bg-slate-50 p-4">
                                    {priceElements.length === 0 ? (
                                        <p className="text-sm text-amber-700">Ainda não tens campos de preço para limitar por tipo.</p>
                                    ) : priceElements.map(element => (
                                        <div key={element.id} className="grid gap-3 md:grid-cols-[1fr_180px] md:items-center">
                                            <span className="text-sm font-semibold text-slate-700">{element.label || 'Campo de preço'}</span>
                                            <input
                                                type="number"
                                                value={maxQuantities[element.id] ?? element.maxQuantityPerElement ?? 0}
                                                onChange={(event) => handleMaxQuantityChange(element.id, event)}
                                                onWheel={() => document.activeElement.blur()}
                                                className={inputClass}
                                                min="0"
                                            />
                                        </div>
                                    ))}
                                </div>
                            )}
                        </SectionCard>
                    </div>

                    <aside className="min-w-0 space-y-5 2xl:sticky 2xl:top-[230px] 2xl:self-start">
                        <SectionCard
                            icon={<CheckCircleIcon />}
                            title="Resumo"
                            description="O essencial para avançar."
                        >
                            <div className="space-y-2 text-sm">
                                <div className="flex justify-between rounded-2xl bg-slate-50 px-4 py-3">
                                    <span className="text-slate-600">Nome</span>
                                    <span className={name ? 'font-bold text-emerald-700' : 'font-bold text-red-600'}>{name ? 'OK' : 'Falta'}</span>
                                </div>
                                <div className="flex justify-between rounded-2xl bg-slate-50 px-4 py-3">
                                    <span className="text-slate-600">Chave API</span>
                                    <span className={apiKey.trim()
                                        ? 'font-bold text-emerald-700'
                                        : apiKeyRequired ? 'font-bold text-red-600' : 'font-bold text-slate-600'}>
                                        {apiKey.trim() ? 'OK' : apiKeyRequired ? 'Falta' : 'Opcional'}
                                    </span>
                                </div>
                                <div className="flex justify-between rounded-2xl bg-slate-50 px-4 py-3">
                                    <span className="text-slate-600">Pagamentos</span>
                                    <span className={paymentOptions.length > 0 ? 'font-bold text-emerald-700' : 'font-bold text-red-600'}>{paymentOptions.length}</span>
                                </div>
                                <div className="flex justify-between rounded-2xl bg-slate-50 px-4 py-3">
                                    <span className="text-slate-600">Idioma</span>
                                    <span className="font-bold text-slate-900">{formLanguage}</span>
                                </div>
                            </div>
                        </SectionCard>

                        <SectionCard
                            icon={<EmailIcon />}
                            title="Notificações"
                            description="Comunicação automática após pagamento."
                        >
                            <Field
                                label="Enviar email quando o pagamento for efetuado?"
                                hint="Só funciona se o cliente preencher email no pagamento."
                            >
                                <select
                                    value={String(sendEmailOnPaidWebhook)}
                                    onChange={(event) => setSendEmailOnPaidWebhook(event.target.value === 'true')}
                                    className={selectClass}
                                >
                                    <option value="false">Não</option>
                                    <option value="true">Sim</option>
                                </select>
                            </Field>
                        </SectionCard>

                        <SectionCard
                            icon={<LocationOnIcon />}
                            title="Localização"
                            description="Partilha facilmente a localização de um evento físico."
                        >
                            <Field label="Ligação do Google Maps" hint="No Google Maps, escolhe Partilhar e copia a ligação.">
                                <div className="flex flex-col gap-2 sm:flex-row">
                                    <input
                                        className={inputClass}
                                        type="url"
                                        value={locationUrl}
                                        placeholder="https://maps.app.goo.gl/..."
                                        onChange={(event) => setLocationUrl(event.target.value)}
                                    />
                                    <button
                                        type="button"
                                        disabled={!locationUrl.trim()}
                                        onClick={() => window.open(locationUrl, '_blank', 'noopener,noreferrer')}
                                        className="whitespace-nowrap rounded-2xl border border-slate-300 bg-white px-4 py-3 text-sm font-semibold text-slate-800 shadow-sm transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-50"
                                    >
                                        Abrir ligação
                                    </button>
                                </div>
                            </Field>

                            <details className="mt-4 rounded-2xl border border-slate-200 bg-slate-50 p-4" open={showCoordinates}>
                                <summary className="cursor-pointer text-sm font-semibold text-slate-800" onClick={(event) => { event.preventDefault(); setShowCoordinates(!showCoordinates); }}>
                                    Opções avançadas: mapa incorporado por coordenadas
                                </summary>
                                {showCoordinates && <div className="mt-4 space-y-4">
                                    <Field label="Latitude">
                                        <input
                                            className={inputClass}
                                            type="number"
                                            min="-90"
                                            max="90"
                                            step="any"
                                            value={latitude ?? ''}
                                            onChange={(event) => setLatitude(event.target.value)}
                                        />
                                    </Field>
                                    <Field label="Longitude">
                                        <input
                                            className={inputClass}
                                            type="number"
                                            min="-180"
                                            max="180"
                                            step="any"
                                            value={longitude ?? ''}
                                            onChange={(event) => setLongitude(event.target.value)}
                                        />
                                    </Field>
                                </div>}
                            </details>
                        </SectionCard>

                        <SectionCard
                            icon={<TuneIcon />}
                            title="Privacidade"
                            description="Guarda IP apenas se for necessário."
                        >
                            <Field label="Guardar IP da resposta?">
                                <select
                                    value={String(saveReplyIp)}
                                    onChange={(event) => setSaveReplyIp(event.target.value === 'true')}
                                    className={selectClass}
                                >
                                    <option value="false">Não</option>
                                    <option value="true">Sim</option>
                                </select>
                            </Field>

                            {saveReplyIp && (
                                <div className="mt-4">
                                    <Field label="Mensagem ao utilizador">
                                        <input
                                            className={inputClass}
                                            type="text"
                                            value={ipMessage ?? ''}
                                            placeholder="Exemplo: Por motivos de segurança, o seu IP será guardado."
                                            onChange={(event) => setIpMessage(event.target.value)}
                                        />
                                    </Field>
                                </div>
                            )}
                        </SectionCard>
                    </aside>
                </div>
            </form>

            <Toast
                type="success"
                title="Sucesso"
                message={successMessage}
                onClose={() => setSuccessMessage('')}
            />

            <Toast
                type="success"
                title="Webhooks 2.0 sincronizados"
                message={callbackSuccess}
                onClose={() => setCallbackSuccess('')}
            />

            <Toast
                type="error"
                title="Erro"
                message={callbackError}
                onClose={() => setCallbackError('')}
            />

            <Toast
                type="error"
                title="Erro ao guardar"
                message={showError && errorMessages.length > 0 ? errorMessages.join(' ') : ''}
                onClose={() => setShowError(false)}
            />

            <Toast
                type="warning"
                title="Atenção"
                message={warningMessage}
                onClose={() => setWarningMessage('')}
            />
        </div>
    );
};

export default FormWizard2;
